"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("./routes");
const context_1 = require("../shared/context");
const WrappedApp = () => (react_1.default.createElement(context_1.AppContext.Provider, { value: window.SCP },
    react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(routes_1.App, null))));
window.onload = function () {
    react_dom_1.default.hydrate(react_1.default.createElement(WrappedApp, null), document.getElementById('root'));
};
//# sourceMappingURL=app.js.map